import { computed } from 'vue';
import { showSizeDropdown } from '@nuxt-common/media-card-large/app/modules/size';
import useMembersOfProduct from '~/composables/useMembersOfProduct';

export default function useSizeDropdown() {
  const { memberProducts } = useMembersOfProduct();

  const showDropdown = computed(() =>
    memberProducts.value.some((member) => {
      const sizes = Object.values(member?.traits?.sizes?.sizeMap || {});
      return showSizeDropdown(sizes);
    }),
  );

  return { showDropdown };
}
